import * as TYPES from '../types';

export const addBannerAction = (payload) => {
    return {
        type: TYPES.ADD_BANNER,
        payload: payload
    };
};

export const getAllBannerAction = () => {
    return {
        type: TYPES.GET_ALL_BANNER,
    };
};

export const getAllBannerSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_BANNER_SUCCESS,
        payload: payload
    };
};

export const deleteBannerAction = (payload) => {
    return {
        type: TYPES.DELETE_BANNER,
        payload: payload
    };
};

export const editBannerAction = (payload) => {
    return {
        type: TYPES.EDIT_BANNER,
        payload: payload
    };
};

export const updateBannerStatusAction = (payload) => {
    return {
        type: TYPES.UPDATE_BANNER_STATUS,
        payload: payload
    };
};
